export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Wip 1_08.bff6d586.jpg";